
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class RootSystemsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (300 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const complexity = Math.floor(6 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const draw = () => {
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    let lastX = x, lastY = y;
                    for (let j = 0; j < complexity; j++) {
                        const angle = this.pseudoRandom(x + y + j) * Math.PI * 2;
                        const len = spacing * 0.3 * (0.5 + this.pseudoRandom(j) * 0.5);
                        lastX += Math.cos(angle) * len;
                        lastY += Math.sin(angle) * len;
                        ctx.lineTo(lastX, lastY);
                        
                        // Secondary branch
                        if (this.pseudoRandom(j + 10) > 0.6) {
                            ctx.save();
                            ctx.beginPath();
                            ctx.moveTo(lastX, lastY);
                            const bAngle = angle + (this.pseudoRandom(j) - 0.5) * 1.5;
                            ctx.lineTo(lastX + Math.cos(bAngle) * len * 0.5, lastY + Math.sin(bAngle) * len * 0.5);
                            ctx.stroke();
                            ctx.restore();
                        }
                    }
                    ctx.stroke();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
